<div class="myc-empty-state">
    <h2 class="myc-empty-state__title">{{ 'aumico_analytics_empty_state_title' | i18next }}</h2>
    <p class="myc-empty-state__sub">{{ 'aumico_analytics_empty_state_subtitle' | i18next }}</p>
    <button type="button" class="myc-empty-state__cta" (click)="createProject.emit()">
        {{ 'aumico_analytics_empty_state_cta' | i18next }}
    </button>
</div>
